// extracted by mini-css-extract-plugin
export default {"input":"CommonInputMask_input__xQvjv","label":"CommonInputMask_label__whj9Z","error":"CommonInputMask_error__6Suyc"};